/* eslint-disable */
import axios from '../index'

const getCategories = () => {
  return axios.get('journal/categories')
}
const insert = (data) => {
  return axios.post('/journal/post', data)
}

const api = { getCategories, insert }


export default api;